import React, { useState } from 'react';
import { useAvatar } from '../context/AvatarContext';
import { UserIcon, RefreshCwIcon } from 'lucide-react';
export const AvatarIndicator = ({
  onCursorChange
}) => {
  const {
    avatar,
    setShowAvatarSelection,
    resetAvatar
  } = useAvatar();
  const [showTooltip, setShowTooltip] = useState(false);
  if (!avatar) return null;
  return <div className="fixed bottom-20 right-20 z-40" data-id="element-142">
      <style jsx data-id="element-143">{`
        .avatar-indicator {
          transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          animation: appear 0.5s ease-out forwards;
        }
        @keyframes appear {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .avatar-tooltip {
          position: absolute;
          bottom: calc(100% + 10px);
          right: 0;
          width: 200px;
          transform-origin: bottom right;
          transition: all 0.3s ease;
        }
        .avatar-glow {
          position: absolute;
          inset: -5px;
          border-radius: inherit;
          opacity: 0;
          transition: opacity 0.3s ease;
          z-index: -1;
        }
        .avatar-indicator:hover .avatar-glow {
          opacity: 1;
        }
        .interface-corner {
          position: absolute;
          width: 8px;
          height: 8px;
          opacity: 0;
          transition: all 0.3s ease;
        }
        .corner-tl {
          top: 0;
          left: 0;
          border-top: 1px solid;
          border-left: 1px solid;
        }
        .corner-tr {
          top: 0;
          right: 0;
          border-top: 1px solid;
          border-right: 1px solid;
        }
        .corner-bl {
          bottom: 0;
          left: 0;
          border-bottom: 1px solid;
          border-left: 1px solid;
        }
        .corner-br {
          bottom: 0;
          right: 0;
          border-bottom: 1px solid;
          border-right: 1px solid;
        }
        .avatar-indicator:hover .interface-corner {
          opacity: 1;
          width: 12px;
          height: 12px;
        }
        .avatar-status-ring {
          position: absolute;
          inset: -2px;
          border-radius: 50%;
          border: 1px solid;
          opacity: 0.6;
          z-index: -1;
        }
        @keyframes status-pulse {
          0%,
          100% {
            opacity: 0.4;
            transform: scale(1);
          }
          50% {
            opacity: 0.8;
            transform: scale(1.05);
          }
        }
        .avatar-status-ring {
          animation: status-pulse 3s infinite ease-in-out;
        }
      `}</style>
      <div className="avatar-indicator glass p-2 rounded-full border group relative cursor-pointer" style={{
      borderColor: `${avatar.accent}50`
    }} onClick={() => setShowTooltip(!showTooltip)} onMouseEnter={() => {
      onCursorChange('button');
    }} onMouseLeave={() => {
      onCursorChange('default');
    }} data-id="element-144">
        {/* Interface corners */}
        <div className="interface-corner corner-tl" style={{
        borderColor: avatar.accent
      }} data-id="element-145"></div>
        <div className="interface-corner corner-tr" style={{
        borderColor: avatar.accent
      }} data-id="element-146"></div>
        <div className="interface-corner corner-bl" style={{
        borderColor: avatar.accent
      }} data-id="element-147"></div>
        <div className="interface-corner corner-br" style={{
        borderColor: avatar.accent
      }} data-id="element-148"></div>
        <div className="avatar-status-ring" style={{
        borderColor: avatar.accent
      }} data-id="element-149"></div>
        <div className="avatar-glow" style={{
        boxShadow: `0 0 15px ${avatar.accent}`
      }} data-id="element-150"></div>
        <div className="w-10 h-10 rounded-full overflow-hidden" data-id="element-151">
          <img src={avatar.image} alt={avatar.name} className="w-full h-full object-cover" data-id="element-152" />
        </div>
        {/* Entity type indicator */}
        <div className="absolute -top-1 -right-1 w-5 h-5 rounded-full flex items-center justify-center text-[8px] font-mono border" style={{
        backgroundColor: avatar.accent,
        color: '#030508',
        borderColor: avatar.accent,
        boxShadow: `0 0 8px ${avatar.accent}`
      }} data-id="element-153">
          {avatar.id.charAt(0).toUpperCase()}
        </div>
        {/* Tooltip */}
        {showTooltip && <div className="avatar-tooltip glass border p-3 rounded-lg shadow-lg" style={{
        borderColor: `${avatar.accent}50`,
        boxShadow: `0 0 20px ${avatar.accent}30`
      }} data-id="element-154">
            <div className="flex items-start gap-3" data-id="element-155">
              <div className="w-12 h-12 rounded overflow-hidden flex-shrink-0 relative" data-id="element-156">
                <img src={avatar.image} alt={avatar.name} className="w-full h-full object-cover" data-id="element-157" />
                {/* Interface corners for image */}
                <div className="absolute top-0 left-0 w-3 h-3 border-t border-l" style={{
              borderColor: avatar.accent
            }} data-id="element-158"></div>
                <div className="absolute top-0 right-0 w-3 h-3 border-t border-r" style={{
              borderColor: avatar.accent
            }} data-id="element-159"></div>
                <div className="absolute bottom-0 left-0 w-3 h-3 border-b border-l" style={{
              borderColor: avatar.accent
            }} data-id="element-160"></div>
                <div className="absolute bottom-0 right-0 w-3 h-3 border-b border-r" style={{
              borderColor: avatar.accent
            }} data-id="element-161"></div>
              </div>
              <div className="flex-1" data-id="element-162">
                <h4 className="font-bold font-heading" style={{
              color: avatar.accent,
              textShadow: `0 0 8px ${avatar.accent}80`
            }} data-id="element-163">
                  {avatar.name} ENTITY
                </h4>
                <p className="text-[#a0c0e0] text-xs font-mono mt-1" data-id="element-164">
                  {avatar.description}
                </p>
                <div className="flex mt-3 gap-2" data-id="element-165">
                  <button className="flex items-center justify-center p-1 glass border rounded text-xs font-mono" style={{
                borderColor: `${avatar.accent}50`,
                color: avatar.accent,
                textShadow: `0 0 4px ${avatar.accent}40`
              }} onClick={e => {
                e.stopPropagation();
                setShowAvatarSelection(true);
              }} onMouseEnter={() => onCursorChange('button')} onMouseLeave={() => onCursorChange('button')} data-id="element-166">
                    <UserIcon size={12} className="mr-1" data-id="element-167" />
                    CHANGE
                  </button>
                  <button className="flex items-center justify-center p-1 glass border rounded text-xs font-mono text-[#8a9cb9] border-[#8a9cb9]/30" onClick={e => {
                e.stopPropagation();
                resetAvatar();
              }} onMouseEnter={() => onCursorChange('button')} onMouseLeave={() => onCursorChange('button')} data-id="element-168">
                    <RefreshCwIcon size={12} className="mr-1" data-id="element-169" />
                    RESET
                  </button>
                </div>
              </div>
            </div>
          </div>}
      </div>
    </div>;
};